import { EMediaType } from 'shared/components/Gallery';
import { EVideoType } from 'shared/types/api-models/offer-card/v1/get-offer-data';

export const MAP_VIDEO_TYPE_TO_MEDIA_TYPE: Record<EVideoType, EMediaType> = {
  [EVideoType.Youtube]: EMediaType.Video,
  [EVideoType.Kinescope]: EMediaType.VideoKinescope,
  [EVideoType.Vk]: EMediaType.VideoVk,
  [EVideoType.Rutube]: EMediaType.VideoRutube,
};
